import { PageHero } from '@/components/PageHero';
import { Chapters } from '@/components/Chapters';
import { Marquee } from '@/components/Marquee';
import { CtaBanner } from '@/components/CtaBanner';
import { Reveal } from '@/components/Reveal';
import { useSeo } from '@/components/Seo';
import { STATIC_IT } from '@/data/staticIt';
import { STATIC_EN } from '@/data/staticEn';
import { useLang } from '@/i18n/LangContext';

export default function Missione() {
  const { lang, t } = useLang();
  const c = lang === 'en' ? STATIC_EN.missione : STATIC_IT.missione;
  useSeo(c.seo);

  return (
    <div data-testid="missione-page">
      <PageHero
        eyebrow={c.eyebrow}
        title={c.title}
        summary={c.summary}
        image="/assets/area-aziende.webp"
        imageAlt={c.title}
        breadcrumbs={[{ label: t('breadcrumbHome'), href: '/' }, { label: t('breadcrumbHome') === 'Home' ? 'Chi siamo' : 'About us', href: '/chi-siamo' }, { label: c.eyebrow }]}
      />
      <Marquee items={c.marquee} />
      <Chapters items={c.manifesto.items} eyebrow={c.manifesto.eyebrow} title={c.manifesto.title} />
      <div className="mx-auto max-w-site px-5 md:px-8 pb-8">
        <Reveal className="max-w-3xl mx-auto text-center py-10">
          <p className="font-heading text-2xl md:text-3xl font-bold tracking-tight leading-snug text-balance">
            {c.quote}
          </p>
        </Reveal>
      </div>
      <div className="mx-auto max-w-site px-5 md:px-8">
        <CtaBanner
          title={c.cta.title}
          text={c.cta.text}
          label={c.cta.label}
        />
      </div>
    </div>
  );
}
